import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as Utils from '../utils.js';
import * as Actions from '../actions/appActions';
import Footer from '../components/footer';
import OktaLogin from '../components/login';
import _ from 'lodash';
import PortalHeader from '../components/portalHeader';
import I18nUtils from '../i18n/i18n.utils';

import(

    /* webpackPrefetch: true */

    './app'
);

import(

    /* webpackPrefetch: true */

    './dashboard'
);

const ConnectedOktaLogin = connect(state => {
    if (state.oktaLogin && state.oktaLogin.data) {
        return {
            status: state.oktaLogin.data.status || 'LOGIN',
            stateToken: state.oktaLogin.data.stateToken || '',
            factorId: state.oktaLogin.data.factorId,
            userId: state.oktaLogin.data.userId,
            href: state.oktaLogin.data.href,
            sessionToken: state.oktaLogin.data.sessionToken,
            verifyToken: state.oktaLogin.data.verifyToken,
            answer: state.oktaLogin.data.answer,
            securityQuestion: state.oktaLogin.data.securityQuestion,
            error: state.oktaLogin.error || null,
            loading: state.oktaLogin.loading,
            parallel_jwt: state.oktaLogin.data.parallel_jwt,
            passwordComplexity: state.oktaLogin.data.passwordComplexity,
            companyUrl: state.oktaLogin && state.oktaLogin.companyUrl,
            securityQuestions: state.oktaLogin.securityQuestions,
            userDetails: state.oktaLogin.data.userDetails,
            sharedSecret: state.oktaLogin.data.sharedSecret,
            userEmail: state.oktaLogin.data.userEmail,
        };
    } else {
        return {
            status: 'LOGIN',
            error: (state.oktaLogin && state.oktaLogin.error) || null,
            loading: (state.oktaLogin && state.oktaLogin.loading) || false,
        };
    }
})(OktaLogin);

class Login extends Component {
    componentDidMount() {
        let user = Utils.loadUserProfile();

        if (user) {
            //CHECK
            this.props.LoggedIn();
            if (this.props.tabItems) {
                this.props.applicationTabSelected(this.props.tabItems[0]);
            }
        } else {
            this.props.UnAuthorized(false);
        }

        if (_.get(this.props, 'location.state.verifyToken')) {
            const vt = this.props.location.state.vt;
            const a = this.props.location.state.a;
            if (this.props.location.state.answer) {
                this.props.VerifyAndAnswer(vt, a);
            } else {
                this.props.Verify(vt, a);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!!nextProps.jwt && !!nextProps.parallel_jwt && nextProps.status !== 'API_USER') {
            if (this.props.jwt !== nextProps.jwt) {
                Utils.setIdToken(nextProps.jwt, nextProps.parallel_jwt);
                this.props.RedirectToApplication();
            }
        }

        if (nextProps.status === 'API_USER') {
            this.props.UnAuthorized();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!!nextProps.jwt && !!nextProps.parallel_jwt) return false;

        return true;
    }

    render() {
        return I18nUtils.i18nWrap(
            <div className="sign-in-wrapper">
                <PortalHeader />
                <div>
                    <ConnectedOktaLogin isParallel={true} />
                </div>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        tabItems: state.taber && state.taber.data && state.taber.data.payload,
        jwt: (state.oktaLogin && state.oktaLogin.data && state.oktaLogin.data.jwt) || '',
        parallel_jwt: (state.oktaLogin && state.oktaLogin.data && state.oktaLogin.data.parallel_jwt) || '',
        url: (state.taber && state.taber.selectedItem && state.taber.selectedItem.Url) || '',
        status: (state.oktaLogin && state.oktaLogin.data && state.oktaLogin.data.status) || '',
    };
};

const mapDispatchToProps = dispatch => ({
    LoggedIn: () => dispatch(Actions.LoggedIn()),
    UnAuthorized: isGoToLogin => dispatch(Actions.UnAuthorized(isGoToLogin)),
    applicationTabSelected: item => dispatch(Actions.applicationTabSelected(item)),
    VerifyAndAnswer: (token, answer) => dispatch(Actions.VerifyAndAnswer(token, answer)),
    Verify: token => dispatch(Actions.Verify(token)),
    RedirectToApplication: () => dispatch(Actions.RedirectToApplication()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);
